import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getExtractionConfigurationsQueryKey } from "Configurations/Api/Queries/useExtractionConfigurationsQuery";
import type { CreateExtractionConfigurationCommand } from "Infrastructure/Api/Api";
import { postExtractionConfigurations } from "Infrastructure/Api/Api";

export function useCreateExtractionConfigurationMutation() {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (command: CreateExtractionConfigurationCommand) =>
			postExtractionConfigurations(command),
		onSuccess: () => {
			// Invalidate extraction configurations query to refetch the list
			queryClient.invalidateQueries({
				queryKey: [getExtractionConfigurationsQueryKey(0, 100)],
			});
		},
	});
}
